<template>
  <div class="bg-white rounded-lg shadow p-4 space-y-1.5 text-sm">
    <div class="text-base font-semibold text-dark-primary">{{ fullName || '--' }}</div>
    <div class="grid grid-cols-3 gap-x-2">
      <span class="text-gray-500">Email</span>
      <a v-if="contact.personal_email" :href="`mailto:${contact.personal_email}`" class="col-span-2 truncate text-accent-primary" @click.stop>{{ contact.personal_email }}</a>
      <span v-else class="col-span-2">--</span>
    </div>
    <div class="grid grid-cols-3 gap-x-2">
      <span class="text-gray-500">LinkedIn</span>
      <a v-if="contact.linkedin_profile" :href="linkedinUrl(contact.linkedin_profile)" target="_blank" rel="noopener" class="col-span-2 truncate text-accent-primary" @click.stop>{{ contact.linkedin_profile }}</a>
      <span v-else class="col-span-2">--</span>
    </div>
    <div class="grid grid-cols-3 gap-x-2">
      <span class="text-gray-500">Phone</span>
      <a v-if="contact.personal_phone" :href="`tel:${contact.personal_phone}`" class="col-span-2 truncate text-accent-primary" @click.stop>{{ contact.personal_phone }}</a>
      <span v-else class="col-span-2">--</span>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { linkedinUrl } from '@/components/mobile/contact/contactDisplay';

const props = defineProps({
  contact: { type: Object, required: true },
})

const fullName = computed(() => [props.contact.first_name, props.contact.last_name].filter(Boolean).join(' '))
</script>
